import React from 'react';
import PropTypes from 'prop-types';
import { NavLink } from 'react-router-dom';

import SelectSoftware from './SelectSoftware';
import MindbodyAuthorization from './MindbodyAuthorization';
import BookerAuthorization from './Booker';
import ZenotiAutorization from './Zenoti';
import ZenotiSucces from './Zenoti/SetupSuccess';
import MeevoAutorization from './Meevo';
import MeevoSucces from './Meevo/SetupSuccess';
import MyTimeAutorization from './MyTime';
import MyTimeSucces from './MyTime/SetupSuccess';
import BoulevardAutorization from './boulevard';
import BoulevardSucces from './boulevard/SetupSuccess';
import AcuitySucces from './Acuity/SetupSuccess';
import AcuityAuthorization from './Acuity';
import RestoreSucces from './Restore/SetupSuccess';
import RestoreAuthorization from './Restore';
import PhorestAuthorization from './Phorest';
import PhorestSuccess from './Phorest/SetupSuccess';
import NonIntegratedSoftwareAuthorization from './NonIntegratedSoftwareAuthorization';
import MindbodyVerify from './MindbodyVerify';
import SoftwareSetupSuccess from './SoftwareSetupSuccess';
import DentalAuthorization from './DentalAuthorization';
import { Loader, Tab } from './../UIComponents';
import Footnote from './../Footnote';

import BookingSoftwares, {
  MINDBODY,
  BOOKER,
  ZENOTI,
  ACUITY,
  PHOREST,
  MYTIME,
  BOULEVARD,
  RESTORE,
  MEEVO
} from './../../assets/BookingSoftwares';
import { DENTAL } from '../../assets/Domains';

import './index.scss';

export default class SoftwareSetup extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      selected: 1,
      comeback: false,
      zenotiAuthType:'STAFF_LOGIN'
    };

    this.onTabChange = this.onTabChange.bind(this);
    this.onBackClick = this.onBackClick.bind(this);
    this.onSoftwareSetupComplete = this.onSoftwareSetupComplete.bind(this);
    this.onSoftwareSuccessDone = this.onSoftwareSuccessDone.bind(this);
  }

  componentDidMount() {
    // Get Bookings Software Info
    this.props.getBookingSoftware();
  }

  componentWillReceiveProps(nextProps) {
    const newState = {
      selected: 1,
      comeback: false,
    };
    let hasStateChanged = false;

    if (
      typeof nextProps.softwares.isSoftwareSaved === 'boolean' &&
      nextProps.softwares.isSoftwareSaved !==
        this.props.softwares.isSoftwareSaved &&
      nextProps.softwares.isSoftwareSaved
    ) {
      newState.selected = 2;
      hasStateChanged = true;
    }

    if (
      typeof nextProps.softwares.isVerified === 'boolean' &&
      nextProps.softwares.isVerified !== this.props.softwares.isVerified &&
      nextProps.softwares.isVerified
    ) {
      newState.selected = 3;
      hasStateChanged = true;
    }

    if (
      typeof nextProps.softwares.isRequested === 'boolean' &&
      nextProps.softwares.isRequested !== this.props.softwares.isRequested &&
      nextProps.softwares.isRequested
    ) {
      newState.selected = 3;
      hasStateChanged = true;
    }

    if (
      typeof nextProps.softwares.isApproved === 'boolean' &&
      nextProps.softwares.isApproved !== this.props.softwares.isApproved &&
      nextProps.softwares.isApproved
    ) {
      newState.selected = 3;
      hasStateChanged = true;
    }
    // if (
    //   typeof nextProps.softwares.zenotiStaffCredLogin === 'boolean' &&
    //   nextProps.softwares.zenotiStaffCredLogin !== this.props.softwares.zenotiStaffCredLogin &&
    //   nextProps.softwares.zenotiStaffCredLogin ===true
    // ) {
    //   newState.selected = 3;
    //   hasStateChanged = true;
    // }

    if (
      typeof nextProps.softwares.isActivated === 'boolean' &&
      nextProps.softwares.isActivated !== this.props.softwares.isActivated &&
      nextProps.softwares.isActivated
    ) {
      this.props.postBookingSoftwareVerification();
    }
    if(nextProps.softwares.form!==this.props.softwares.form){
      this.setState({
        zenotiAuthType: nextProps.softwares?.form?.api_key?'API_KEY':'STAFF_LOGIN'
      })
    }

    if (hasStateChanged) {
      this.setState(newState);
    }
  }

  onTabChange(value) {
    this.setState({
      selected: value,
    });
  }

  onBackClick(count = 1) {
    console.log('backclick', this.state);
    this.setState({
      comeback: true,
    });
    if (this.state.selected > 1) {
      this.setState({
        selected: this.state.selected - count,
      });
      console.log('backclick', this.state);
    } else if (this.state.selected === 1) {
      // Check if booking software is already selected
      if (this.props.softwares.isSoftwareSelected) {
        // Reset booking software selection status
        this.props.resetSoftwareSelection();
      } else {
        // Redirect to summary screen
        this.props.history.push('/app/setup');
      }
    }
  }
  onNextClick = () => {
    this.setState({
      comeback: false,
    });
  };
  onSoftwareSetupComplete() {
    this.props.history.push('/app/setup/phone');
  }

  // Show this screen, if user has filled up all info for other software setup and seen the success message
  onSoftwareSuccessDone() {
    this.props.getBookingSoftware();
    this.props.history.push('/app/setup');
    this.props.clearBookingSoftwareFlg();
  }

  onzenotiAuthTypeChange=(auth)=>{
    this.setState({
      zenotiAuthType:auth
    })
  }

  render() {
    if (this.props.currentDomain === DENTAL) {
      return (
        <DentalAuthorization {...this.props} onBackClick={this.onBackClick} />
      );
    }

    const connectBokingSoftwareTabs = [
      {
        value: 1,
        text: 'Software',
        isComplete: !!this.props.softwares.isSoftwareSaved,
      },
      {
        value: 2,
        text: 'Authorization',
        isComplete: !!this.props.softwares.isActivated,
      },
    ];

    const ZenotiBookingTabs = [
      { value: 1, text: 'Software', isComplete: true },
      {
        value: 2,
        text: 'Create Staff Login',
        isComplete: !!this.props.softwares.isActivated,
      },
      {
        value: 3,
        text: 'Authorization',
        isComplete: this.props.softwares.isZenotiAutorized,
      },
    ];
    const ZenotiNewBookingTabsLocationAccount = [
      { value: 1, text: 'Software', isComplete: true },
      {
        value: 2,
        text: 'Provide Authorization credentials',
        isComplete: !!this.props.softwares.isActivated,
      },
      {
        value: 3,
        text: 'Configure Setup',
        isComplete: this.props.softwares.isZenotiAutorized,
      },
      {
        value: 4,
        text: 'Authorization',
        isComplete: this.props.softwares.isZenotiAutorized,
      },
    ];

    const ZenotiNewBookingTabsBrandAccount = [
      { value: 1, text: 'Software', isComplete: true },
      {
        value: 2,
        text: 'Provide Authorization credentials',
        isComplete: !!this.props.softwares.isActivated,
      },
      {
        value: 3,
        text: 'Authorization',
        isComplete: this.props.softwares.isZenotiAutorized,
      },
    ];

    const AcuityBookingTabsLocationAccount = [
      { value: 1, text: 'Software', isComplete: true },
      {
        value: 2,
        text: 'Authorization',
        isComplete: this.props.softwares.isZenotiAutorized,
      },
      {
        value: 3,
        text: 'Configure Setup',
        isComplete: this.props.softwares.isZenotiAutorized,
      },
      {
        value: 4,
        text: 'Create Staff Login',
        isComplete: !!this.props.softwares.isActivated,
      },
    ];

    const AcuityBookingTabsBrandAccount = [
      { value: 1, text: 'Software', isComplete: true },
      {
        value: 2,
        text: 'Authorization',
        isComplete: this.props.softwares.isZenotiAutorized,
      },
      {
        value: 3,
        text: 'Configure Setup',
        isComplete: this.props.softwares.isZenotiAutorized,
      },
    ];

    let loaderWidth;
    switch (this.state.selected) {
      default:
      case 1:
        loaderWidth = 5;
        break;
      case 2:
        loaderWidth = 100 / 2;
        break;
      case 3:
        loaderWidth = 98;
        break;
    }

    let authorizationComponent;

    switch (this.props.softwares.selectedSoftware) {
      case MINDBODY:
        authorizationComponent = (
          <MindbodyAuthorization
            {...this.props}
            onBackClick={this.onBackClick}
          />
        );
        break;

      case BOOKER:
        authorizationComponent = (
          <BookerAuthorization {...this.props} onBackClick={this.onBackClick} />
        );
        break;

      case ZENOTI:
        authorizationComponent = (
          <ZenotiAutorization {...this.props} onBackClick={this.onBackClick} zenotiAuthType={this.state.zenotiAuthType} onzenotiAuthTypeChange={this.onzenotiAuthTypeChange}/>
        );
        break;
      
        case MEEVO:
          authorizationComponent = (
            <MeevoAutorization {...this.props} onBackClick={this.onBackClick} zenotiAuthType={this.state.zenotiAuthType} onzenotiAuthTypeChange={this.onzenotiAuthTypeChange}/>
          );
          break;

      case ACUITY:
        authorizationComponent = (
          <AcuityAuthorization {...this.props} onBackClick={this.onBackClick} zenotiAuthType={this.state.zenotiAuthType} onzenotiAuthTypeChange={this.onzenotiAuthTypeChange} />
        );
        break;

      case RESTORE:
        authorizationComponent = (
          <RestoreAuthorization
            {...this.props}
            onBackClick={this.onBackClick}
          />
        );
        break;

      case PHOREST:
        authorizationComponent = (
          <PhorestAuthorization
            {...this.props}
            onBackClick={this.onBackClick}
          />
        );
        break;

      case MYTIME:
        authorizationComponent = (
          <MyTimeAutorization {...this.props} onBackClick={this.onBackClick} />
        );
        break;

      case BOULEVARD:
        authorizationComponent = (
          <BoulevardAutorization
            {...this.props}
            onBackClick={this.onBackClick}
          />
        );
        break;

      default:
        authorizationComponent = (
          <NonIntegratedSoftwareAuthorization
            {...this.props}
            onBackClick={this.onBackClick}
          />
        );
        break;
    }

    let firstScreen;
    if (this.state.selected === 1 && !this.props.softwares.isSoftwareSelected) {
      firstScreen = (
        <SelectSoftware
          {...this.props}
          onBackClick={this.onBackClick}
          onNextClick={this.onNextClick}
        />
      );
    } else if (
      this.state.selected === 1 &&
      this.props.softwares.isSoftwareSelected
    ) {
      firstScreen = authorizationComponent;
    } else {
      firstScreen = undefined;
    }

    const bookingSoftware =
      BookingSoftwares[this.props.softwares.selectedSoftware] || {};

    if (this.props.softwares.selectedSoftware === BOOKER) {
      let bookerLoaderWidth = 25;
      if (this.props.softwares.isBookerAccountInfoSaveSuccess) {
        bookerLoaderWidth = 50;
      }

      if (this.props.softwares.isBookerEmailSendSuccess) {
        bookerLoaderWidth = 75;
      }

      if (this.props.softwares.isRequested) {
        bookerLoaderWidth = 100;
      }

      return (
        <div className="booking-software">
          <p className="booking-software__text">
            {this.props.dashboard.tasksStatus.bookingSW_connect !== 'completed'
              ? `Please authorize TrueLark to access your ${bookingSoftware.label ||
                  'software'} schedule`
              : `TrueLark has access to your ${bookingSoftware.label ||
                  'software'} schedule`}
          </p>
          <div className="connect-booking-software">
            <div className="connect-booking-software__card">
              <div className="card">
                <div className="card__header">
                  <span className="card__header__text">
                    {bookingSoftware.label || 'Software'} authorization
                  </span>
                  <NavLink
                    className="connect-booking-software__card__help"
                    to="/app/help"
                  >
                    Need help?
                  </NavLink>
                </div>
                <Loader width={`${bookerLoaderWidth}%`} />
                <div className="card__content">
                  <div className="connect-booking-software__card__content">
                    {!this.props.softwares.isRequested ? (
                      <Tab
                        tabs={connectBokingSoftwareTabs}
                        selected={
                          this.props.softwares.isBookerEmailSendSuccess ? 2 : 1
                        }
                        onTabChange={this.onTabChange}
                      />
                    ) : null}
                    <BookerAuthorization
                      {...this.props}
                      onBackClick={this.onBackClick}
                    />
                  </div>
                </div>
              </div>
            </div>
            <Footnote />
          </div>
        </div>
      );
    } else if (this.props.softwares.selectedSoftware === ZENOTI) {
      let selectedTab = 2;
      let successScreen = false;
      let showTab = true;
      loaderWidth = 25;
      if (this.props.softwares.isZenotiAccountInfoSaveSuccess) {
        loaderWidth = 40;
        selectedTab = 2;
      }
      if (this.props.softwares.zenotiStaffCredLogin) {
        loaderWidth = 60;
        selectedTab = 3;
      }
      if (this.props.softwares.isZenotiConfigureSetup) {
        loaderWidth = 60;
        selectedTab = 3;
      }
      if (this.props.softwares.isZenotiReferral) {
        loaderWidth = 80;
        selectedTab = 4;
      }
      if (this.props.softwares.staffCredentialsSaveFail) {
        successScreen = true;
        loaderWidth = 100;
      }
      if (this.props.softwares.isZenotiAutorized) {
        successScreen = true;
        loaderWidth = 100;
      }
      if (this.props.softwares.isZenotiAutorizationFail) {
        successScreen = true;
        loaderWidth = 100;
        showTab = false;
      }
      return (
        <div className="booking-software">
          <p className="booking-software__text">
            {this.props.dashboard.tasksStatus.bookingSW_connect !== 'completed'
              ? `Please authorize TrueLark to access your ${bookingSoftware.label ||
                  'software'} schedule`
              : `TrueLark has access to your ${bookingSoftware.label ||
                  'software'} schedule`}
          </p>
          <div className="connect-booking-software">
            <div className="connect-booking-software__card">
              <div className="card">
                <div className="card__header">
                  <span className="card__header__text">
                    {bookingSoftware.label || 'Software'} authorization
                  </span>
                  <NavLink
                    className="connect-booking-software__card__help"
                    to="/app/help"
                  >
                    Need help?
                  </NavLink>
                </div>
                <Loader width={`${loaderWidth}%`} />
                <div className="card__content">
                  {successScreen ? (
                    <ZenotiSucces
                      {...this.props}
                      onBackClick={this.onBackClick}
                      onNextClick={this.onSoftwareSetupComplete}
                      onOkClick={this.onSoftwareSuccessDone}
                    />
                  ) : (
                    <div className="connect-booking-software__card__content">
                      {showTab && (
                        <Tab
                          tabs={this.props.softwares.brand ? ZenotiNewBookingTabsBrandAccount :
                                                    ZenotiNewBookingTabsLocationAccount}
                          isZenoti={true}
                          selected={selectedTab}
                          onTabChange={this.onTabChange}
                        />
                      )}
                      {firstScreen}
                      {this.state.selected === 2 ? (
                        <ZenotiAutorization
                          {...this.props}
                          onBackClick={this.onBackClick}
                        />
                      ) : (
                        undefined
                      )}
                    </div>
                  )}
                </div>
              </div>
            </div>
            <Footnote />
          </div>
        </div>
      );
    } else if (this.props.softwares.selectedSoftware === MEEVO) {
      let selectedTab = 2;
      let successScreen = false;
      let showTab = true;
      loaderWidth = 25;
      if (this.props.softwares.isZenotiAccountInfoSaveSuccess) {
        loaderWidth = 40;
        selectedTab = 2;
      }
      if (this.props.softwares.zenotiStaffCredLogin) {
        loaderWidth = 60;
        selectedTab = 3;
      }
      if (this.props.softwares.isZenotiConfigureSetup) {
        loaderWidth = 80;
        selectedTab = 4;
      }
      if (this.props.softwares.staffCredentialsSaveFail) {
        successScreen = true;
        loaderWidth = 100;
      }
      if (this.props.softwares.isZenotiAutorized) {
        successScreen = true;
        loaderWidth = 100;
      }
      if (this.props.softwares.isZenotiAutorizationFail) {
        successScreen = true;
        loaderWidth = 100;
        showTab = false;
      }
      return (
        <div className="booking-software">
          <p className="booking-software__text">
            {this.props.dashboard.tasksStatus.bookingSW_connect !== 'completed'
              ? `Please authorize TrueLark to access your ${bookingSoftware.label ||
                  'software'} schedule`
              : `TrueLark has access to your ${bookingSoftware.label ||
                  'software'} schedule`}
          </p>
          <div className="connect-booking-software">
            <div className="connect-booking-software__card">
              <div className="card">
                <div className="card__header">
                  <span className="card__header__text">
                    {bookingSoftware.label || 'Software'} authorization
                  </span>
                  <NavLink
                    className="connect-booking-software__card__help"
                    to="/app/help"
                  >
                    Need help?
                  </NavLink>
                </div>
                <Loader width={`${loaderWidth}%`} />
                <div className="card__content">
                  {successScreen ? (
                    <MeevoSucces
                      {...this.props}
                      onBackClick={this.onBackClick}
                      onNextClick={this.onSoftwareSetupComplete}
                      onOkClick={this.onSoftwareSuccessDone}
                    />
                  ) : (
                    <div className="connect-booking-software__card__content">
                      {showTab && (
                        <Tab
                          tabs={this.props.softwares.brand ? ZenotiNewBookingTabsBrandAccount :
                                                    ZenotiNewBookingTabsLocationAccount}
                          isZenoti={true}
                          selected={selectedTab}
                          onTabChange={this.onTabChange}
                        />
                      )}
                      {firstScreen}
                      {this.state.selected === 2 ? (
                        <MeevoAutorization
                          {...this.props}
                          onBackClick={this.onBackClick}
                        />
                      ) : (
                        undefined
                      )}
                    </div>
                  )}
                </div>
              </div>
            </div>
            <Footnote />
          </div>
        </div>
      );
      } else if (this.props.softwares.selectedSoftware === MYTIME) {
      let selectedTab = 2;
      let successScreen = false;
      let showTab = true;
      loaderWidth = 35;
      if (this.props.softwares.isZenotiAccountInfoSaveSuccess) {
        loaderWidth = 50;
        selectedTab = 2;
      }
      if (this.props.softwares.zenotiStaffCredLogin) {
        loaderWidth = 70;
        selectedTab = 3;
      }
      if (this.props.softwares.staffCredentialsSaveFail) {
        successScreen = true;
        loaderWidth = 100;
      }
      if (this.props.softwares.isZenotiAutorized) {
        successScreen = true;
        loaderWidth = 100;
      }
      if (this.props.softwares.isZenotiAutorizationFail) {
        successScreen = true;
        loaderWidth = 100;
        showTab = false;
      }
      return (
        <div className="booking-software">
          <p className="booking-software__text">
            {this.props.dashboard.tasksStatus.bookingSW_connect !== 'completed'
              ? `Please authorize TrueLark to access your ${bookingSoftware.label ||
                  'software'} schedule`
              : `TrueLark has access to your ${bookingSoftware.label ||
                  'software'} schedule`}
          </p>
          <div className="connect-booking-software">
            <div className="connect-booking-software__card">
              <div className="card">
                <div className="card__header">
                  <span className="card__header__text">
                    {bookingSoftware.label || 'Software'} authorization
                  </span>
                  <NavLink
                    className="connect-booking-software__card__help"
                    to="/app/help"
                  >
                    Need help?
                  </NavLink>
                </div>
                <Loader width={`${loaderWidth}%`} />
                <div className="card__content">
                  {successScreen ? (
                    <MyTimeSucces
                      {...this.props}
                      onBackClick={this.onBackClick}
                      onNextClick={this.onSoftwareSetupComplete}
                      onOkClick={this.onSoftwareSuccessDone}
                    />
                  ) : (
                    <div className="connect-booking-software__card__content">
                      {showTab && (
                        <Tab
                          tabs={ZenotiBookingTabs}
                          selected={selectedTab}
                          onTabChange={this.onTabChange}
                        />
                      )}
                      {firstScreen}
                      {this.state.selected === 2 ? (
                        <MyTimeAutorization
                          {...this.props}
                          onBackClick={this.onBackClick}
                        />
                      ) : (
                        undefined
                      )}
                    </div>
                  )}
                </div>
              </div>
            </div>
            <Footnote />
          </div>
        </div>
      );
    } else if (this.props.softwares.selectedSoftware === BOULEVARD) {
      let bookerLoaderWidth = 25;
      let successScreen = false;
      if (this.props.softwares.isBookerAccountInfoSaveSuccess) {
        bookerLoaderWidth = 50;
      }

      if (this.props.softwares.isBookerEmailSendSuccess) {
        bookerLoaderWidth = 75;
      }

      if (this.props.softwares.isRequested) {
        bookerLoaderWidth = 100;
      }
      if (this.props.softwares.staffCredSaved) {
        successScreen = true;
      }

      return (
        <div className="booking-software">
          <p className="booking-software__text">
            {this.props.dashboard.tasksStatus.bookingSW_connect !== 'completed'
              ? `Please authorize TrueLark to access your ${bookingSoftware.label ||
                  'software'} schedule`
              : `TrueLark has access to your ${bookingSoftware.label ||
                  'software'} schedule`}
          </p>
          <div className="connect-booking-software">
            <div className="connect-booking-software__card">
              <div className="card">
                <div className="card__header">
                  <span className="card__header__text">
                    {bookingSoftware.label || 'Software'} authorization
                  </span>
                  <NavLink
                    className="connect-booking-software__card__help"
                    to="/app/help"
                  >
                    Need help?
                  </NavLink>
                </div>
                <Loader width={`${bookerLoaderWidth}%`} />
                <div className="card__content">
                  {successScreen ? (
                    <BoulevardSucces
                      {...this.props}
                      onBackClick={this.onBackClick}
                      onNextClick={this.onSoftwareSetupComplete}
                      onOkClick={this.onSoftwareSuccessDone}
                    />
                  ) : (
                    <div className="connect-booking-software__card__content">
                      {!this.props.softwares.isRequested ? (
                        <Tab
                          tabs={connectBokingSoftwareTabs}
                          selected={
                            this.props.softwares.isBookerEmailSendSuccess
                              ? 2
                              : 1
                          }
                          onTabChange={this.onTabChange}
                        />
                      ) : null}
                      <BoulevardAutorization
                        {...this.props}
                        onBackClick={this.onBackClick}
                        onOkClick={this.onSoftwareSuccessDone}
                      />
                    </div>
                  )}
                </div>
              </div>
            </div>
            <Footnote />
          </div>
        </div>
      );
    } else if (this.props.softwares.selectedSoftware === ACUITY) {
      let selectedTab = 2;
      let successScreen = false;
      let showTab = true;
      loaderWidth = 25;
      if (this.props.softwares.isZenotiAccountInfoSaveSuccess) {
        loaderWidth = 40;
        selectedTab = 3;
      }
      if (this.props.softwares.isZenotiConfigureSetup) {
        loaderWidth = 60;
        selectedTab = 4;
      }

      if (this.props.softwares.isZenotiAutorized) {
        selectedTab = 4;
        loaderWidth = 100;
        successScreen = true;
        showTab = false;
      }
      if (this.props.softwares.zenotiStaffCredLogin) {
        loaderWidth = 100;
        // successScreen = true;
        // showTab = false;
      }
      if (this.props.softwares.staffCredentialsSaveFail) {
        successScreen = true;
        loaderWidth = 100;
        showTab = false;
      }
      if (this.props.softwares.isZenotiAutorizationFail) {
        successScreen = true;
        loaderWidth = 100;
        showTab = false;
      }
      return (
        <div className="booking-software">
          <p className="booking-software__text">
            {this.props.dashboard.tasksStatus.bookingSW_connect !== 'completed'
              ? `Please authorize TrueLark to access your ${bookingSoftware.label ||
                  'software'} schedule`
              : `TrueLark has access to your ${bookingSoftware.label ||
                  'software'} schedule`}
          </p>
          <div className="connect-booking-software">
            <div className="connect-booking-software__card">
              <div className="card">
                <div className="card__header">
                  <span className="card__header__text">
                    {bookingSoftware.label || 'Software'} authorization
                  </span>
                  <NavLink
                    className="connect-booking-software__card__help"
                    to="/app/help"
                  >
                    Need help?
                  </NavLink>
                </div>
                <Loader width={`${loaderWidth}%`} />
                <div className="card__content">
                  {successScreen ? (
                    <AcuitySucces
                      {...this.props}
                      onBackClick={this.onBackClick}
                      onNextClick={this.onSoftwareSetupComplete}
                      onOkClick={this.onSoftwareSuccessDone}
                    />
                  ) : (
                    <div className="connect-booking-software__card__content">
                      {showTab && (
                        <Tab 
                          tabs={this.props.softwares.brand ? AcuityBookingTabsBrandAccount :
                            AcuityBookingTabsLocationAccount}
                          selected={selectedTab}
                          onTabChange={this.onTabChange}
                        />
                      )}
                      {firstScreen}
                      {this.state.selected === 2 ? (
                        <AcuityAuthorization
                          {...this.props}
                          onBackClick={this.onBackClick}
                        />
                      ) : (
                        undefined
                      )}
                    </div>
                  )}
                </div>
              </div>
            </div>
            <Footnote />
          </div>
        </div>
      );
    } else if (this.props.softwares.selectedSoftware === RESTORE) {
      let selectedTab = 2;
      let successScreen = false;
      let showTab = true;
      loaderWidth = 35;
      if (this.props.softwares.isZenotiAccountInfoSaveSuccess) {
        loaderWidth = 50;
        selectedTab = 2;
      }
      if (this.props.softwares.isZenotiAutorized) {
        selectedTab = 3;
        loaderWidth = 70;
      }
      if (this.props.softwares.zenotiStaffCredLogin) {
        loaderWidth = 100;
        successScreen = true;
      }
      if (this.props.softwares.staffCredentialsSaveFail) {
        successScreen = true;
        loaderWidth = 100;
      }
      if (this.props.softwares.isZenotiAutorizationFail) {
        successScreen = true;
        loaderWidth = 100;
        showTab = false;
      }
      return (
        <div className="booking-software">
          <p className="booking-software__text">
            {this.props.dashboard.tasksStatus.bookingSW_connect !== 'completed'
              ? `Please authorize TrueLark to access your ${bookingSoftware.label ||
                  'software'} schedule`
              : `TrueLark has access to your ${bookingSoftware.label ||
                  'software'} schedule`}
          </p>
          <div className="connect-booking-software">
            <div className="connect-booking-software__card">
              <div className="card">
                <div className="card__header">
                  <span className="card__header__text">
                    {bookingSoftware.label || 'Software'} authorization
                  </span>
                  <NavLink
                    className="connect-booking-software__card__help"
                    to="/app/help"
                  >
                    Need help?
                  </NavLink>
                </div>
                <Loader width={`${loaderWidth}%`} />
                <div className="card__content">
                  {successScreen ? (
                    <RestoreSucces
                      {...this.props}
                      onBackClick={this.onBackClick}
                      onNextClick={this.onSoftwareSetupComplete}
                      onOkClick={this.onSoftwareSuccessDone}
                    />
                  ) : (
                    <div className="connect-booking-software__card__content">
                      {showTab && (
                        <Tab
                          tabs={AcuityBookingTabsLocationAccount}
                          selected={selectedTab}
                          onTabChange={this.onTabChange}
                        />
                      )}
                      {firstScreen}
                      {this.state.selected === 2 ? (
                        <AcuityAuthorization
                          {...this.props}
                          onBackClick={this.onBackClick}
                        />
                      ) : (
                        undefined
                      )}
                    </div>
                  )}
                </div>
              </div>
            </div>
            <Footnote />
          </div>
        </div>
      );
    } else if (this.props.softwares.selectedSoftware === PHOREST) {
      let selectedTab = 2;
      let successScreen = false;
      let showTab = true;
      loaderWidth = 35;
      if (this.state.comeback) {
        selectedTab = 1;
      }
      if (this.props.softwares.isZenotiAccountInfoSaveSuccess) {
        loaderWidth = 50;
        selectedTab = 2;
      }
      if (this.props.softwares.zenotiStaffCredLogin) {
        loaderWidth = 70;
        selectedTab = 3;
      }
      if (this.props.softwares.staffCredentialsSaveFail) {
        successScreen = true;
        loaderWidth = 100;
      }
      if (this.props.softwares.isZenotiAutorized) {
        successScreen = true;
        loaderWidth = 100;
      }
      if (this.props.softwares.isZenotiAutorizationFail) {
        successScreen = true;
        loaderWidth = 100;
        showTab = false;
      }
      return (
        <div className="booking-software">
          <p className="booking-software__text">
            {this.props.dashboard.tasksStatus.bookingSW_connect !== 'completed'
              ? `Please authorize TrueLark to access your ${bookingSoftware.label ||
                  'software'} schedule`
              : `TrueLark has access to your ${bookingSoftware.label ||
                  'software'} schedule`}
          </p>
          <div className="connect-booking-software">
            <div className="connect-booking-software__card">
              <div className="card">
                <div className="card__header">
                  <span className="card__header__text">
                    {bookingSoftware.label || 'Software'} authorization
                  </span>
                  <NavLink
                    className="connect-booking-software__card__help"
                    to="/app/help"
                  >
                    Need help?
                  </NavLink>
                </div>
                <Loader width={`${loaderWidth}%`} />
                <div className="card__content">
                  {successScreen ? (
                    <PhorestSuccess
                      {...this.props}
                      onBackClick={this.onBackClick}
                      onNextClick={this.onSoftwareSetupComplete}
                      onOkClick={this.onSoftwareSuccessDone}
                    />
                  ) : (
                    <div className="connect-booking-software__card__content">
                      {showTab && (
                        <Tab
                          tabs={ZenotiBookingTabs}
                          selected={selectedTab}
                          onTabChange={this.onTabChange}
                        />
                      )}
                      {firstScreen}
                      {this.state.selected === 2 ? (
                        <PhorestAuthorization
                          {...this.props}
                          onBackClick={this.onBackClick}
                        />
                      ) : (
                        undefined
                      )}
                    </div>
                  )}
                </div>
              </div>
            </div>
            <Footnote />
          </div>
        </div>
      );
    }

    return (
      <div className="booking-software">
        <p className="booking-software__text">
          {this.props.dashboard.tasksStatus.bookingSW_connect !== 'completed'
            ? `Please authorize TrueLark to access your ${bookingSoftware.label ||
                'software'} schedule`
            : `TrueLark has access to your ${bookingSoftware.label ||
                'software'} schedule`}
        </p>
        <div className="connect-booking-software">
          <div className="connect-booking-software__card">
            <div className="card">
              <div className="card__header">
                <span className="card__header__text">
                  {bookingSoftware.label || 'Software'} authorization
                </span>
                <NavLink
                  className="connect-booking-software__card__help"
                  to="/app/help"
                >
                  Need help?
                </NavLink>
              </div>
              <Loader width={`${loaderWidth}%`} />
              <div className="card__content">
                {this.state.selected === 3 ? (
                  <SoftwareSetupSuccess
                    {...this.props}
                    onBackClick={this.onBackClick}
                    onNextClick={this.onSoftwareSetupComplete}
                    onOkClick={this.onSoftwareSuccessDone}
                  />
                ) : (
                  <div className="connect-booking-software__card__content">
                    <Tab
                      tabs={connectBokingSoftwareTabs}
                      selected={this.state.selected}
                      onTabChange={this.onTabChange}
                    />
                    {firstScreen}
                    {this.state.selected === 2 ? (
                      <MindbodyVerify
                        {...this.props}
                        onBackClick={this.onBackClick}
                      />
                    ) : (
                      undefined
                    )}
                  </div>
                )}
              </div>
            </div>
          </div>
          <Footnote />
        </div>
      </div>
    );
  }
}

SoftwareSetup.defaultProps = {
  getBookingSoftware: () => {},
  resetSoftwareSelection: () => {},
  postBookingSoftwareVerification: () => {},
  currentDomain: '',
  router: {
    push: () => {},
  },
};

SoftwareSetup.propTypes = {
  getBookingSoftware: PropTypes.func,
  resetSoftwareSelection: PropTypes.func,
  postBookingSoftwareVerification: PropTypes.func,
  currentDomain: PropTypes.string,
  softwares: PropTypes.shape({
    selectedSoftware: PropTypes.string,
    isSoftwareSaved: PropTypes.bool,
    isSoftwareSelected: PropTypes.bool,
    isActivated: PropTypes.bool,
    isVerified: PropTypes.bool,
    isRequested: PropTypes.bool,
    isBookerAccountInfoSaveSuccess: PropTypes.bool,
    isBookerEmailSendSuccess: PropTypes.bool,
    isZenotiAutorized: PropTypes.bool,
    staffCredentialsSaveFail: PropTypes.bool,
    isApproved: PropTypes.bool,
    status: PropTypes.shape({
      isSetup: PropTypes.bool,
    }),
    isZenotiAccountInfoSaveSuccess: PropTypes.bool,
  }).isRequired,
  dashboard: PropTypes.shape({
    tasksStatus: PropTypes.shape({
      bookingSW_connect: PropTypes.string,
    }),
  }).isRequired,
  router: PropTypes.shape({
    push: PropTypes.func,
  }),
};
